import { render, staticRenderFns } from "./SetAccountModal.vue?vue&type=template&id=71cc367c&scoped=true"
import script from "./SetAccountModal.vue?vue&type=script&lang=js"
export * from "./SetAccountModal.vue?vue&type=script&lang=js"
import style0 from "./SetAccountModal.vue?vue&type=style&index=0&id=71cc367c&prod&scoped=true&lang=scss"
import style1 from "./SetAccountModal.vue?vue&type=style&index=1&id=71cc367c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc367c",
  null
  
)

export default component.exports